import type { WidgetRegistration } from '@ayocore/platform/client/widgets';
import { SalesTrendWidget } from './SalesTrendWidget';

export { SalesTrendWidget };
export const salesTrendWidget = {
  code: 'crm.sales-trend',
  title: 'Продажи',
  Component: SalesTrendWidget,
  welcome: { key: 'crm-sales-trend', order: 50, span: 6 },
} satisfies WidgetRegistration;
